(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["engagement"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
        new Swiper(".product-details__engagement_items", {
            slidesPerView: 1,
            effect: "fade",
            fadeEffect: {
                crossFade: true,
            },
            loop: true,
            speed: 1000,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },
        });
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('.filter-format__wrapper');
  const prevBtn = document.querySelector('.filter-format__prev');
  const nextBtn = document.querySelector('.filter-format__next');

  if (document.querySelector('#MainContent')) {
    document.querySelector('#MainContent').addEventListener('click', function (e) {
      if (e.target.closest('.facets-filter__close')) {
        document.querySelector('.filter-collapse')?.classList.remove('show');
      }
    });
  }

  if (!slider) return;

  // Prev / Next navigation
  const scrollAmount = 250;

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      slider.scrollBy({
        left: -scrollAmount,
        behavior: 'smooth'
      });
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      slider.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    });
  }

  // Drag scroll
  let isDown = false;
  let startX;
  let scrollLeft;

  slider.addEventListener('mousedown', function (e) {
    isDown = true;
    slider.classList.add('is-dragging');
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });

  slider.addEventListener('mouseleave', function () {
    isDown = false;
    slider.classList.remove('is-dragging');
  });

  slider.addEventListener('mouseup', function () {
    isDown = false;
    slider.classList.remove('is-dragging');
  });

  slider.addEventListener('mousemove', function (e) {
    if (!isDown) return;
    e.preventDefault();

    const x = e.pageX - slider.offsetLeft;
    const walk = x - startX;

    slider.scrollLeft = scrollLeft - walk;
  });
});
  } catch(e) { console.error(e); }
})();

})();
